import React, { useState } from "react";
import { TextField, Dialog, TableContainer, Table, TableBody, TableRow, TableCell } from "@mui/material";
import { useSelector } from "react-redux";
import { updatePassword } from "./../../../services/api";
import { useTranslation } from "react-i18next";
import ButtonWithAPICall from "./../../commons/ButtonWithAPICall.component";

const initialInputData = {
  currentPassword: "",
  newPassword: "",
  confirmPassword: "",
};

export default function Profile({ open, onClose }) {
  // custom hook
  const [t] = useTranslation();

  // redux state
  const user = useSelector((state) => state.user.data);

  // state
  const [inputData, setInputData] = useState({ ...initialInputData });

  // method
  const handleSubmit = () => {
    return updatePassword(user.id, {
      current_password: inputData.currentPassword,
      password: inputData.newPassword,
      password_confirmation: inputData.confirmPassword,
    });
  };
  const handleResponse = (res) => {
    if (res.code === 200) {
      setInputData({ ...initialInputData });
    }
  };
  if (user)
    return (
      <Dialog open={open} onClose={onClose} maxWidth={false}>
        <div style={{ padding: 20 }}>
          <div align="left">
            <b>{t("Thông tin cơ bản")}</b>:
          </div>
          <TableContainer>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell align="left">
                    {t("Tên")}: {user.name}
                  </TableCell>
                  <TableCell align="left">Email: {user.email}</TableCell>
                  <TableCell align="left">
                    {t("Nhóm người dùng")}: {user.organization}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left" colSpan={3}>
                    {t("Phòng/ban")}: {user.department_name}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <div align="left" style={{ marginTop: 10 }}>
            <b>{t("Đổi mật khẩu")}</b>:
          </div>
          <TextField
            label="Current password"
            fullWidth
            type="password"
            value={inputData.currentPassword}
            onChange={(e) => setInputData((prev) => ({ ...prev, currentPassword: e.target.value }))}
            style={{ margin: "10px 0" }}
          />
          <TextField
            label="New password"
            fullWidth
            type="password"
            value={inputData.newPassword}
            onChange={(e) => setInputData((prev) => ({ ...prev, newPassword: e.target.value }))}
            style={{ margin: "10px 0" }}
          />
          <TextField
            label="Confirm new password"
            fullWidth
            type="password"
            value={inputData.confirmPassword}
            onChange={(e) => setInputData((prev) => ({ ...prev, confirmPassword: e.target.value }))}
            style={{ margin: "10px 0" }}
          />
          <ButtonWithAPICall variant="contained" style={{ margin: 5 }} api={handleSubmit} response={handleResponse}>
            {t("Lưu")}
          </ButtonWithAPICall>
        </div>
      </Dialog>
    );
  else return "";
}
